<template>
  <div class>
    <Toast />

    <div class="card css-table">
      <DataTable
        :value="warehouse_outbounds"
        :loading="loading.filter"
        :rowHover="true"
        :selection.sync="selectedItems"
      >
        <template #empty>Data tidak tersedia.</template>
        <template #loading
          >Mengambil data daftar cetak barang. Mohon tunggu.</template
        >
        <h5>
          <b>List Cetak Harga</b>
        </h5>
        <template #header>
          <div class="p-grid p-fluid p-mb-3">
            <div class="p-col-12 p-md-6 p-lg-2">
              <label for="">Supplier</label> <br />
              <AutoComplete
                placeholder="Pilih Supplier"
                :dropdown="true"
                :multiple="false"
                v-model="selected_supplier"
                :suggestions="filtered_suppliers"
                @complete="searchSupplier($event)"
                @input="is_error.supplier = false"
                field="alias"
              />
            </div>
            <div class="p-col-12 p-md-6 p-lg-2">
              <label for="">Outlet</label>
              <AutoComplete
                placeholder="Pilih Outlet"
                :dropdown="true"
                :multiple="false"
                v-model="selected_outlet"
                :suggestions="outlets"
                @complete="getOutlets($event)"
                @input="is_error.outlet = false"
                field="code"
              >
                <template #item="slotProps">
                  <div style="font-style: italic; font-size: 12px">
                    {{ slotProps.item.code }}
                  </div>
                </template>
              </AutoComplete>
              <small class="p-error" v-if="is_error.outlet">{{
                error_msg.outlet
              }}</small>
            </div>
            <div class="p-col-12 p-md-6 p-lg-2">
              <label for="">Nomer Bon</label> <br />
              <InputText placeholder="Nomer Bon" v-model="filter.doc_number" />
            </div>
            <div class="p-col-12 p-md-6 p-lg-2">
              <label for="">Tanggal Bon</label> <br />
              <InputText type="date" v-model="filter.doc_date" />
            </div>
            <div class="p-col-12 p-md-6 p-lg-2">
              <label for="">Purchase Bon Number</label> <br />
              <InputText
                placeholder="Purchase Doc Number"
                v-model="filter.purchase_doc_number"
              />
            </div>
          </div>

          <div class="p-grid p-justify-center p-mb-4">
            <div class="p-col-12 p-md-6 p-lg-3">
              <button
                class="btn btn-primary"
                :disabled="loading.filter"
                @click="getWarehouseOutbounds()"
                style="width: 100%"
              >
                Cari Barcode
                <span v-if="loading.filter">
                  <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
                </span>
              </button>
            </div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-md-3 p-lg-3">
              <Checkbox
                v-model="filter.show_all"
                :binary="true"
                @change="showAll()"
              />
              <label
                for=""
                style="padding-left: 5px; margin-bottom: 0px; margin-top: 5px"
                >Tampilkan semua</label
              >
            </div>
          </div>
        </template>

        <Column field="cat_no" header="No" headerStyle="width: 3em">
          <template #body="slotProps">
            {{ warehouse_outbounds.indexOf(slotProps.data) + 1 }}
          </template>
        </Column>
        <Column header="Kode Barang" headerStyle="width: 12em;">
          <template #body="slotProps">
            <span> {{ slotProps.data.item_code }} </span>
          </template>
        </Column>
        <Column header="Nama Barang">
          <template #body="slotProps">
            <span> {{ slotProps.data.item_name }} </span>
          </template>
        </Column>
        <Column header="Nomer Bon">
          <template #body="slotProps">
            <span> {{ slotProps.data.doc_number }} </span>
          </template>
        </Column>
        <Column header="Tanggal Bon">
          <template #body="slotProps">
            <span> {{ slotProps.data.doc_date }} </span>
          </template>
        </Column>
        <Column header="Harga">
          <template #body="slotProps">
            <span>{{ slotProps.data.price | currency }}</span>
          </template>
        </Column>
        <Column header="Jumlah">
          <template #body="slotProps">
            <InputNumber
              class="input-number-size"
              locale="id-ID"
              placeholder="0"
              v-model.number="slotProps.data.number"
              @update:model-value="onNumberInput(slotProps.data.id, $event)"
            />
          </template>
        </Column>
        <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      </DataTable>

      <div
        class="p-grid p-justify-center p-mt-4"
        v-if="warehouse_outbounds.length != 0 && selectedItems.length != 0"
      >
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            class="btn btn-primary"
            @click="printBarcode()"
            style="width: 100%"
          >
            Cetak
          </button>
        </div>
      </div>

      <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
        <Dialog
          :visible.sync="print_dialog"
          :style="{ width: '450px' }"
          header="Print Barcode"
          :modal="true"
          class="p-fluid"
        >
          <div class="confirmation-content">
            <i class="pi pi-print p-mr-3" style="font-size: 1rem" />
            <span> Please click save to download the barcode </span>
          </div>
          <template #footer>
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="print_dialog = false"
            />
            <Button
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveClicked()"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
let moment = require('moment')

export default {
  data() {
    return {
      moment: moment,
      outlets: [],
      selected_outlet: '',

      loading: {
        filter: false
      },

      filter: {
        show_all: false,
        doc_number: '',
        doc_date: '',
        barcode_date: '',
        supplier_value: true,
        purchase_doc_number: ''
      },

      print_dialog: false,

      suppliers: [],
      filtered_suppliers: [],
      selected_supplier: '',

      limit: 1000,
      loading_ok: false,

      warehouse_outbounds: [],
      selectedItems: [],
      selectedItems_id: '',
      ids: [],

      barcodes: null,

      is_error: {
        supplier: false,
        outlet: false
      },

      error_msg: {
        supplier: '',
        outlet: ''
      }
    }
  },

  mounted() {
    this.getSuppliers()
  },

  methods: {
    showAll() {
      this.warehouse_outbounds = []
      this.selected_supplier = ''
      this.selected_outlet = ''
      this.filter.barcode_date = ''
      this.filter.doc_number = ''
      this.filter.doc_date = ''
      this.filter.purchase_doc_number = ''

      this.getSuppliers()
    },

    getSuppliers(event) {
      if (this.filter.show_all) {
        let name = ''
        let code = ''
        let page = 1

        if (event) {
          page = event.page + 1
        }

        if (event.query != null && event.query.match(/^[a-zA-Z]+$/)) {
          name = event.query
        } else if (event.query.match(/^[a-zA-Z0-9]+$/)) {
          code = event.query
        }

        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/suppliers?name=${name}&code=${code}&page=${page}&limit=5`
          )
          .then(response => {
            if (response.status === 200) {
              this.suppliers = response.data.data.suppliers
              let query = event.query
              let autoFiltered = []
              for (const supplier of this.suppliers) {
                if (
                  supplier.name.toLowerCase().indexOf(query.toLowerCase()) ===
                    0 ||
                  supplier.code.toLowerCase().indexOf(query.toLowerCase()) === 0
                ) {
                  autoFiltered.push(supplier)
                }
              }
              this.filtered_suppliers = autoFiltered
            }
          })
      } else {
        this.$http
          .get(
            `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/suppliers?mutation_price=true&status=0`
          )
          .then(response => {
            if (response.status === 200) {
              this.suppliers = response.data.data.suppliers
            }
          })
      }
    },

    searchSupplier(event) {
      if (this.filter.show_all) {
        this.getSuppliers(event)
      } else {
        this.filtered_suppliers = this.suppliers
          .filter(item => {
            return (
              item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
              item.code.toLowerCase().startsWith(event.query.toLowerCase())
            )
          })
          .map(item => {
            return {
              code: item.code,
              id: item.id,
              name: item.name,
              alias: `${item.code} - ${item.name}`
            }
          })
      }
      this.filter.supplier_value = false
    },

    getWarehouseOutbounds(event) {
      let type = 'PRICE_MUTATION'

      let doc_date = this.filter.doc_date
        ? moment(this.filter.doc_date).format('YYYY-MM-DD')
        : ''

      let page = 1
      if (event) {
        page = event.page + 1
      }
      let id_supplier = null
      if (this.selected_supplier == '') {
        id_supplier = 0
      } else {
        id_supplier = this.selected_supplier.id
      }

      let selected_outlet
      if (this.selected_outlet == null || isNaN(this.selected_outlet.id)) {
        selected_outlet = ''
      } else {
        selected_outlet = parseInt(this.selected_outlet.id)
      }

      const endpoint = `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds?doc_number=${this.filter.doc_number}&doc_date=${doc_date}&type=${type}&outlet_id=${selected_outlet}&sup_id=${id_supplier}&page=${page}&limit=${this.limit}&status=0`

      this.loading.filter = true
      this.$http.get(endpoint).then(response => {
        this.loading.filter = false
        if (response.status === 200) {
          this.warehouse_outbounds = response.data.data.warehouse_outbound
          this.total_records = response.data.data.total
        }
      })
    },

    getOutlets(event) {
      let name = ''
      let code = ''

      if (event.query != null && event.query.match(/^[a-zA-Z]+$/)) {
        name = event.query
      } else if (event.query.match(/^[a-zA-Z0-9]+$/)) {
        code = event.query
      }
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlets?name=${name}&code=${code}`)
        .then(response => {
          if (response.status === 200) {
            this.outlets = response.data.data.outlets.map(outlet => {
              return {
                code: `${outlet.code} - ${outlet.name}`,
                id: outlet.id
              }
            })
          }
        })
    },

    async saveClicked() {
      this.loading_ok = true
      let warehouseOutboundList = this.warehouse_outbounds
        .filter(item => this.ids.includes(item.id))
        .map(item => ({
          warehouse_outbound_id: item.id,
          number: item.number ? parseInt(item.number) : 0
        }))

      try {
        const printResponse = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/price-mutations/printed-barcode`,
          { warehouse_outbound: warehouseOutboundList }
        )

        if (printResponse.status === 200 && printResponse.data.success) {
          const barcodeData = printResponse.data.data.barcode
          let file = new Blob([barcodeData], {
            type: 'text/plain;charset=utf-8'
          })
          saveAs(file, 'price_barcodes.txt')

          const statusResponse = await this.$http.patch(
            `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/printed-barcode`,
            { ids: this.ids }
          )

          if (statusResponse.status === 200 && statusResponse.data.success) {
            this.showToast(
              'success',
              'Success',
              'Berhasil mencetak barcode dan mengubah status'
            )
            this.getWarehouseOutbounds()
          } else {
            throw new Error('Failed to change status')
          }
        } else {
          throw new Error('Failed to generate barcode')
        }
      } catch (error) {
        console.error(error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal mencetak barcode atau mengubah status',
          life: 3000
        })
      } finally {
        this.loading_ok = false
        this.print_dialog = false
      }
    },

    printBarcode() {
      this.selectedItems_id = ''
      this.ids = []
      this.print_dialog = true
      if (this.selectedItems.length == 1) {
        this.selectedItems_id = this.selectedItems[0].id
        this.ids.push(this.selectedItems[0].id)
      } else {
        for (let i = 0; i < this.selectedItems.length; i++) {
          let item = this.selectedItems[i]
          this.ids.push(item.id)
          this.selectedItems_id += item.id
          if (i != this.selectedItems.length - 1) this.selectedItems_id += ','
        }
      }
      this.getSuppliers()
    }
  }
}
</script>

<style scoped></style>
